<template>
  <div>
    <div container>
      <div class="_flex mb-2">
        <div class="btns-left">
          <button class="btn btn-primary --sm mr-2" @click="togglePaidInvoices()">
            {{showPaidInvoices ? 'Hide Paid Invoices': 'Show Paid Invoices'}}
          </button>

          <month-input
            v-model="selectedMonth"
            :months="monthFilterList"
            @input="updateSelectedMonth"
          ></month-input>
        </div>
        <!-- <button :disabled="invoices.length === 0"
         class="btn btn-primary --sm" @click="toggleFilters()">
          filter {{ filterCounter }}
        </button> -->
        <div class="right">
          <async-button
            v-if="isInternalUser"
            class="btn white --sm _mrxs"
            :executing="isUnBlocking"
            :disabled="selectedInvoices.length === 0"
            @clicked="unblock(selectedInvoices)"
          >
            <template #buttonContent>
              <span>unblock</span>
            </template>
          </async-button>
          <async-button
            v-if="isInternalUser"
            class="btn white --sm _mrxs"
            :executing="isBlocking"
            :disabled="selectedInvoices.length === 0"
            @clicked="block(selectedInvoices)"
          >
            <template #buttonContent>
              <span>block</span>
            </template>
          </async-button>

          <async-dropdown-link
            title="Download"
            :loading="multipleReportsIsDownloading"
            :disabled="filteredInvoices.length === 0"
            class="download-link _mls _mt0 btn --sm white"
          >
            <li class="my-1" @click="handleDownloadSelection($event, 'ROSTER' )">
              Rosters
              <font-awesome-icon
                :icon="['fa', 'file-archive']"
                aria-label="download invoice"
              ></font-awesome-icon>
            </li>
            <li class="my-1" @click="handleDownloadSelection($event,'SUMMARY')">
              Invoices
              <font-awesome-icon
                :icon="['fa', 'file-archive']"
                aria-label="download invoice"
              ></font-awesome-icon>
            </li>
            <li
              class="my-1"
              @click="handleDownloadSelection($event,'ALL')"
            >
              Rosters & Invoices
              <font-awesome-icon
                :icon="['fa', 'file-archive']"
                aria-label="download invoice"
              ></font-awesome-icon>
            </li>
          </async-dropdown-link>
          <button :disabled="filteredInvoices.length === 0"
           class="btn btn-primary --sm ml-2" @click="toggleCardView()">
            {{ showDetailedView ? 'Compact View' : 'Detailed View' }}
          </button>
        </div>
      </div>
      <!-- <transition name="slide-fade">
        <div v-if="showFilters" class="_flex mb-2">
          <button class="btn btn-link --sm mr-2" @click="togglePaidInvoices()">
            {{showPaidInvoices ? 'Hide Paid Invoices': 'Show Paid Invoices'}}
          </button>

          <month-input
            v-model="selectedMonth"
            :months="monthFilterList"
            @input="updateSelectedMonth"
          ></month-input>
        </div>
      </transition> -->
    </div>
    <div v-if="invoicesLoading">
      <async-loader></async-loader>
    </div>
    <div container v-else-if="!transformedInvoices.length">
      <p class="card-invoice elevation-2 mx-0 px-4 py-4 _text-center">
        {{ filterCounter ? 'Invoice(s) not found for the filter criteria.' : invoicesUserMessage }}
      </p>
    </div>
    <div
      v-else
      v-for="invoiceGL in transformedInvoices"
      :key="invoiceGL.groupCk"
    >
      <div
        class="_pt0 _pb0 bg-white section-header _bb1 _bt1 py-0"
      >
        <div container class="group-header">
          <h1 class="color-lips">{{ invoiceGL.groupName }}</h1>
          <div class="_text-right">
            <h1 class="color-lips">
              {{ toDollarFormat(invoiceGL.groupTotal)}}
            </h1>
            <p class="color-moon mb-0">Group Total</p>
          </div>
        </div>
      </div>
      <invoices-group
        :groupedInvoices="invoiceGL.groupInvoices"
        :showDetailedView="showDetailedView"
        :selected="selectedInvoices"
        :hideCheckBox="!isInternalUser"
        @toggleSelection="toggleSelection"
      ></invoices-group>
    </div>
  </div>
</template>

<script>
  import billing from '@mixins/billing'
  import AsyncDropdownLink from '@atoms/AsyncDropdownLink'
  import { now, formatMMMtoM } from '@/utils'
  import formattable from '@mixins/formattable'
  import MonthInput from './MonthInput'
  import AsyncButton from '@molecules/AsyncButton'
  import { mapActions, mapGetters, mapMutations } from 'vuex'
  import { SET_FILTERED_INVOICES } from '@store/modules/billing/mutationTypes'
  import {
    BLOCK_INVOICES,
    UNBLOCK_INVOICES,
    GET_INVOICES
  } from '@store/modules/billing/actionTypes'
  import reporting from '@mixins/reporting'
  import InvoicesGroup from './InvoicesGroup'

  export default {
    mixins: [billing, reporting, formattable],
    components: {
      AsyncDropdownLink,
      AsyncButton,
      MonthInput,
      InvoicesGroup
    },
    data() {
      return {
        showFilters: true,
        showDetailedView: false,
        showPaidInvoices: false,
        dateFilter: false,
        allInvoices: [],
        allButNotPaidInvoices: [],
        transformedInvoices: [],
        selectedMonth: null,
        monthFilterList: [],
        selectedInvoices: []
      }
    },
    methods: {
      ...mapActions({
        block: BLOCK_INVOICES,
        unblock: UNBLOCK_INVOICES,
        getInvoices: GET_INVOICES
      }),
      ...mapMutations({
        setFilteredInvoices: SET_FILTERED_INVOICES
      }),
      toggleFilters() {
        this.showFilters = !this.showFilters
      },
      toggleCardView() {
        this.showDetailedView = !this.showDetailedView
      },
      filterInvoices() {
        let filteredInvoices = this.showPaidInvoices ? this.allInvoices : this.allButNotPaidInvoices;
        if(this.selectedMonth) {
          filteredInvoices = filteredInvoices.filter(inv => inv.displayInvoiceDate === this.selectedMonth);
        }
        if(this.showPaidInvoices) {
          this.monthFilterList = this.allInvoices.map(inv => inv.invoiceDate);
        }
        else {
          this.monthFilterList = this.allButNotPaidInvoices.map(inv => inv.invoiceDate);
        }
        this.setFilteredInvoices(filteredInvoices)
      },
      togglePaidInvoices() {
        this.showPaidInvoices = !this.showPaidInvoices
        this.filterInvoices()
      },
      updateSelectedMonth() {
        this.filterInvoices()
      },
      transformInvoices(invoices) {
        if (!invoices.length) {
          this.transformedInvoices = []
        } else {
          let groupfilter = Object.values(this.groupByGroup(invoices, 'groupCk'))
          groupfilter.forEach(gl => {
            gl.groupInvoices = Object.values(
              this.groupBySubGroup(gl.groupInvoices, 'subGroupCk')
            )
          })

          this.transformedInvoices = Object.values(groupfilter)
        }
      },

      groupBySubGroup(array, key) {
        return array.reduce((result, currentValue) => {
          if (!result[currentValue.subGroupCk]) {
            result[currentValue.subGroupCk] = {
              subGroupName: currentValue.subGroup,
              subGroupCk: currentValue.subGroupCk,
              subGroupTotal: 0,
              subGroupInvoices: []
            }
          }
          result[currentValue.subGroupCk].subGroupTotal += (!currentValue.block && currentValue.openAmount) || 0.0
          result[currentValue.subGroupCk].subGroupInvoices.push(currentValue)
          return result
        }, {})
      },
      groupByGroup(array, key) {
        return array.reduce((result, currentValue) => {
          if (!result[currentValue.groupCk]) {
            result[currentValue.groupCk] = {
              groupName: currentValue.group,
              groupCk: currentValue.groupCk,
              groupTotal: 0,
              groupInvoices: [],
              groupInvoiceNumberType: []
            }
          }
          result[currentValue.groupCk].groupTotal += (!currentValue.block && currentValue.openAmount) || 0.0
          result[currentValue.groupCk].groupInvoices.push(currentValue)
          result[currentValue.groupCk].groupInvoiceNumberType.push({
            invoiceNumber: currentValue.invoiceNumber,
            invoiceType: currentValue.invoiceType
          }
          )
          return result
        }, {})
      },
      toggleSelection(newValue) {
        this.$set(this, 'selectedInvoices', newValue)
      },
      exportToCSV() {
        let csvContent = []
        let csvHelpers = [
          { text: 'Group', value: 'group', visible: true },
          { text: 'Subgroup', value: 'subGroup', visible: true },
          { text: 'Invoice No.', value: 'invoiceNumber' },
          { text: 'Invoice Date', value: 'invoiceDate' },
          { text: 'Invoice Type', value: 'invoiceDescription' },
          { text: 'Invoice Status', value: 'paymentStatus' },
          { text: 'Invoice Amount', value: 'displayInvoiceAmount' },
          { text: 'Balance', value: 'displayBalance' },
          { text: 'Payment Date', value: 'paidDate' },
          { text: 'Paid Amount', value: 'displayPaidAmount' },
          { text: 'Adjustments', value: 'displayAdjustmentAmount' }
        ]

        let firstRow = csvHelpers.map(helper => helper.text)
        csvContent.push(firstRow)
        const groupContent = []
        this.transformedInvoices.forEach(f => {
          f.groupInvoices.forEach(gf => {
            gf.subGroupInvoices.map(sf => {
              if (sf.block === false) {
                groupContent.push(sf)
              }
            })
          })
        })

        groupContent
          .map(invoice => {
            return csvHelpers.map(helper => `\"${invoice[helper.value]}\"`)
          })
          .forEach(row => csvContent.push(row))

        let csvString = csvContent.map(line => line.join(',')).join('\r\n')

        let a = document.createElement('a')
        let csvData = new Blob([csvString], { encoding: 'UTF-8', type: 'text/csv;charset=UTF-8' })
        a.href = URL.createObjectURL(csvData)
        a.download = `Invoice_Summary_${now()}.csv`
        document.body.appendChild(a)
        a.click()
      },
      handleDownloadSelection(e, invoiceType) {
        let status = !this.showPaidInvoices ? 'OPEN' : 'ALL'
        let month, year

        if (this.selectedMonth) {
          month = this.selectedMonth.split(' ')[0]
          month = formatMMMtoM(month)
          year = this.selectedMonth.split(' ')[1]
        }
        const downloadObj = {
          invoiceType: invoiceType,
          year: year || ' ',
          month: month || ' ',
          status: status,
          fileName: `${e.target.innerText}_${now()}.zip`
        }

        this.handleMultipleFileDownload({ ...downloadObj })
      }
    },
    computed: {
      ...mapGetters(['isBlocking', 'isUnBlocking']),
      multipleReportsIsDownloading() {
        return this.$store.getters['reporting/multipleReportsIsDownloading'] || false;
      },  
      filterCounter() {
        if (!this.showPaidInvoices && !this.selectedMonth) return null
        else {
          return this.showPaidInvoices && this.selectedMonth ? '(2)' : '(1)'
        }
      }
    },
    watch: {
      invoices(newInvoices) {
        console.log(`watch invoices`, newInvoices);
        this.allInvoices = newInvoices
        this.allButNotPaidInvoices = newInvoices.filter(inv => inv.paymentStatus !== 'PAID')
        this.filterInvoices()
      },
      filteredInvoices(newFilterInvoices) {
        this.transformInvoices(newFilterInvoices)
      }
    }
  }
</script>

<style lang="scss" scoped>
.icon-dropdown.download-link.btn {
  .svg-inline--fa {
    position: initial;
    top: auto;
    transform: initial;
    margin-left: 5px;
  }
}

.group-header {
  display: flex;
  justify-content: space-between;
  align-items:flex-start;
}

.btns-left {
  display: flex;
  flex-direction: row;
  padding-right: 4rem;
  margin-bottom: 0.5rem;
}
</style>
